module.exports = __webpack_public_path__ + "img/compact.39622174.png";